import { Box, Flex } from "@chakra-ui/react";
import { Outlet, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar, { SIDEBAR_WIDTH } from "../Sidebar";
import Topbar from "../Topbar";
import { colors } from "../../theme";

const TOPBAR_HEIGHT = "70px";

/**
 * DashboardLayout - Protected wrapper for all dashboard routes
 *
 * Structure:
 * - Sidebar (fixed, 250px width)
 * - Main Content Area
 *   - Topbar (fixed, 70px height)
 *   - Page Content (Outlet)
 */
const DashboardLayout = () => {
  const { isAuthenticated } = useSelector((state) => state.user);

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Flex bg={colors.background} padding={5} height={"100vh"}>
      {/* Sidebar - Fixed */}
      <Sidebar />

      {/* Main Content Area */}
      <Box flex={1} ml={5} display="flex" flexDirection="column">
        {/* Topbar - Fixed */}
        <Topbar />

        {/* Page Content - Scrollable */}
        <Box
          as="main"
          flex={1}
          mt={5}
          p={6}
          overflowY="auto"
          bg={"#fff"}
          borderRadius={16}
        >
          <Outlet />
        </Box>
      </Box>
    </Flex>
  );
};

export default DashboardLayout;
